import "./QuickActions.css";

export const QuickActions = ({ actions, onAction, visible }) => {
  if (!visible) return null;

  return (
    <div className="quick-actions">
      {actions.map((action, idx) => (
        <button
          key={idx}
          className="quick-action-btn"
          onClick={() => onAction(action)}
        >
          {action}
        </button>
      ))}
    </div>
  );
};
